import React, {Component} from 'react';
import ReactImageMagnify from 'react-image-magnify';

class PicturePanel extends Component {

  getImageId = (url) =>{
    return url.substring(url.lastIndexOf('/')+1);
  }

  getResizeImage = (url, w, h) =>{
    const host = '//d3r3r4tgtn0hwd.cloudfront.net/'
    //return `${host}${w}x${h}/${this.getImageId(url)}`; disable size because resize function not working now
    return `${host}${this.getImageId(url)}`;
  }
  render(){
    return(
      <div className={`PicturePanel ${this.props.dynamicClass}`}>
        <ReactImageMagnify {...{
            smallImage: {
                alt: 'Flower',
                isFluidWidth: true,
                src: this.getResizeImage(this.props.imgURL, '1200', '1800'),
                sizes: '(max-width: 480px) 100vw, (max-width: 1200px) 30vw, 360px'
            },
            largeImage: {
                src: this.getResizeImage(this.props.imgURL, '1200', '1800'),
                width: 1200,
                height: 1800
            },
            enlargedImageContainerDimensions: {
              width: '100%',
              height: '100%'
          }
        }} />
      </div>
    );
  }
}

export default PicturePanel;



// WEBPACK FOOTER //
// ./src/components/singleItem/picturePanel.js